import menu from "./menu";

/**
 * "Utenti e accessi": il governo della piattaforma, un'app a parte con layout e menu suoi.
 *
 * <p>Il riquadro si vede anche a chi è SUPER_ADMIN ma non ha ancora l'app di autenticazione
 * ({@code consoleServeApp}): entrando trova la spiegazione di cosa manca, invece di non trovare
 * niente senza sapere perché.
 *
 * <p>Nell'app per telefoni non c'è: da lì non si amministra. La condizione è scritta per intero
 * perché webpack la valuta in compilazione.
 */
export default {
  id: "accessi",
  label: "Utenti e accessi",
  icon: "ri-shield-user-line",
  color: "info",
  description: "Chi entra, cosa può fare, cosa consuma.",
  home: "/accessi/panoramica",
  match: ["/accessi"],
  areaDiPiattaforma: true,
  canAccess: (features) => process.env.VUE_APP_PIATTAFORMA !== "mobile"
    && (features.console === true || features.consoleServeApp === true),
  roleLabel: () => "Amministrazione",
  menu,
};
